import { render, staticRenderFns } from "./dadosFtp.vue?vue&type=template&id=4837d2ed&"
import script from "./dadosFtp.vue?vue&type=script&lang=js&"
export * from "./dadosFtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports